package one.healthium.data.user.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class UserSystemDto(
    @SerialName("play_time") val playTime: Int? = null,
)
